var TEXT_SPECIFIC_QUESTION = "text-specific-question"
var BLOG_QUESTION = "blog-question"
var GENERIC_QUESTION = "generic-question"
var REVIEW_QUESTION = "review-question"
var META_COGNITIVE_QUESTION = "meta-cognitive-question"
var FILL_IN_THE_BLANK_QUESTION = "fill-in-the-blank-question"
var ESSAY_QUESTION = "essay-question"

module.exports = {
	TEXT_SPECIFIC_QUESTION, BLOG_QUESTION, GENERIC_QUESTION, REVIEW_QUESTION, META_COGNITIVE_QUESTION, FILL_IN_THE_BLANK_QUESTION, ESSAY_QUESTION,

	BASIC_TYPES: [TEXT_SPECIFIC_QUESTION, GENERIC_QUESTION, ESSAY_QUESTION],

	PRACTICE_QUESTION_TYPES: [TEXT_SPECIFIC_QUESTION, GENERIC_QUESTION]
}


// WEBPACK FOOTER //
// ./modules/lib/academic/QuestionTypes.js